import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { AccountConstructorFactory } from '@webapp/platform/finance'
import {
  ApprovedExpenseItem,
  type ApprovedExpenseItemConstructor,
} from './ApprovedExpenseItem'
import { ExpenseStatuses } from '../enums/ExpenseStatusEnum'
import { ExpenseTypes } from '../enums/ExpenseTypeEnum'

export const ApprovedExpenseItemConstructorFactory =
  Factory.Sync.makeFactory<ApprovedExpenseItemConstructor>({
    id: Factory.each(() => faker.random.number()),
    lineNumber: Factory.each(() => faker.random.number({ min: 1, max: 9 })),
    merchant: Factory.each(() => faker.company.companyName()),
    amount: '100.00',
    currencyId: Factory.each(() => faker.random.number()),
    expenseType: ExpenseTypes.LODGING,
    expenseTypeLabel: 'Lodging',
    attachment: null,
    notes: null,
    approvedDate: Factory.each(() => faker.date.past().toISOString()),
    requester: Factory.each(() => ({
      id: faker.random.number(),
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
    })),
    expenseReport: Factory.each(() => ({
      id: faker.random.number(),
      uuid: faker.random.uuid(),
      status: ExpenseStatuses.APPROVED,
      createdDate: faker.date.past().toISOString(),
      hasSiblingItems: false,
      notes: null,
    })),
    account: Factory.each(() => AccountConstructorFactory.build()),
  })

export const ApprovedExpenseItemFactory = EntityFactory(
  ApprovedExpenseItem,
  ApprovedExpenseItemConstructorFactory
)
